class BannersService {
    constructor(restangular) {
        this._api = restangular.one('banner');
        this.banners = {};
    }

    getBanners({ CategoryId = undefined, IsSpecialRoot = false, SpecialGroupId = undefined }) {
        if (CategoryId && !(CategoryId in this.banners)) {
            this._api.get({ CategoryId, IsSpecialRoot, SpecialGroupId })
                .then((resp) => { this.banners[CategoryId] = resp.BannerResponses; });
        }

        return this.banners[CategoryId];
    }
}

BannersService.$inject = ['Restangular'];

module.exports = BannersService;



// WEBPACK FOOTER //
// ./src/shop/banners/banners.service.js